<template>

    <Toast/>

    <!--    <MenuSiLogin/>-->

    <div class="px-6 surface-overlay relative">

        <div
            class="surface-overlay py-3 px-6 shadow-0 flex align-items-center justify-content-between relative lg:static">
            <img src="images/blocks/logos/logo.simplyinvesting.rev2.png" alt="Simply Investing" height="50"/>
            <a
                v-ripple
                class="cursor-pointer block lg:hidden text-700 mt-1 p-ripple"
                v-styleclass="{
                        selector: '@next',
                        enterClass: 'hidden',
                        leaveToClass: 'hidden',
                        hideOnOutsideClick: true
                    }"
            >
                <i class="pi pi-bars text-4xl"></i>
            </a>
            <div
                class="align-items-center flex-grow-1 justify-content-between hidden lg:flex absolute lg:static w-full surface-overlay left-0 top-100 px-6 lg:px-0 z-5 shadow-2 lg:shadow-none">
                <section></section>
                <div
                    class="flex justify-content-between lg:block border-top-1 lg:border-top-none surface-border py-3 lg:py-0 mt-3 lg:mt-0">
                    <Button @click="processHeaderApp" label="App" class="p-button-text font-bold"></Button>
                    <Button @click="processHeaderCourse" label="Dividend Course"
                            class="p-button-text font-bold"></Button>
                    <Button @click="processHeaderLogin" label="Login" class="p-button-text font-bold"></Button>
                    <Button @click="processHeaderSubscribe" label="Buy Now" class="p-button-text font-bold"></Button>
                </div>
            </div>
        </div>

        <div class="surface-section px-4 py-8 md:px-6 lg:px-8 overflow-hidden">
            <div class="text-900 font-bold text-4xl mb-4 text-center">Payment Cancelled
            </div>

            <div class="grid">
                <div class="col-12 md:col-12">
                    <div class="card p-fluid">

                        <span>
                            Your payment was cancelled. Please try again if want to sign up for a Simply Investing subscription.
                        </span>

                    </div>
                </div>
            </div>

        </div>

        <div class="surface-50 px-4 md:px-6 lg:px-8 border-1 surface-border border-x-none">
            <div class="grid flex-wrap -mr-3 -ml-3 md:text-left">
                <div
                    class="col-12 sm:col-6 md:col-4 lg:col-3 flex flex-column mt-2 py-4 px-4 border-bottom-1 lg:border-y-none md:border-right-1 surface-border">
                    <span class="text-900 text-xl block">Products & Services</span>
                    <ul class="list-none p-0">
                        <li>
                            <a tabindex="0" @click="processFooter1A"
                               class="text-600 hover:text-900 transition-duration-150 cursor-pointer mt-3 block">Simply
                                Investing App</a>
                        </li>
                        <li>
                            <a tabindex="0" @click="processFooter1B"
                               class="text-600 hover:text-900 transition-duration-150 cursor-pointer mt-3 block">App
                                Features</a>
                        </li>
                        <li>
                            <a tabindex="0" @click="processFooter1C"
                               class="text-600 hover:text-900 transition-duration-150 cursor-pointer mt-3 block">App
                                Data</a>
                        </li>
                        <li>
                            <a tabindex="0" @click="processFooter1D"
                               class="text-600 hover:text-900 transition-duration-150 cursor-pointer mt-3 block">Simply
                                Investing Course</a>
                        </li>
                        <li>
                            <a tabindex="0" @click="processFooter1E"
                               class="text-600 hover:text-900 transition-duration-150 cursor-pointer mt-3 block">Personal
                                Coaching Calls</a>
                        </li>
                    </ul>
                </div>
                <div
                    class="col-12 sm:col-6 md:col-4 lg:col-3 flex flex-column mt-2 py-4 px-4 border-bottom-1 lg:border-y-none md:border-right-1 surface-border">
                    <span class="text-900 text-xl block">Simply Investing</span>
                    <ul class="list-none p-0">
                        <li>
                            <a tabindex="0" @click="processFooter2A"
                               class="text-600 hover:text-900 transition-duration-150 cursor-pointer mt-3 block">Our
                                Approach</a>
                        </li>
                        <li>
                            <a tabindex="0" @click="processFooter2B"
                               class="text-600 hover:text-900 transition-duration-150 cursor-pointer mt-3 block">Our
                                Track Record</a>
                        </li>
                        <li>
                            <a tabindex="0" @click="processFooter2C"
                               class="text-600 hover:text-900 transition-duration-150 cursor-pointer mt-3 block">Testimonials</a>
                        </li>
                        <li>
                            <a tabindex="0" @click="processFooter2D"
                               class="text-600 hover:text-900 transition-duration-150 cursor-pointer mt-3 block">About
                                Us</a>
                        </li>
                        <li>
                            <a tabindex="0" @click="processFooter2E"
                               class="text-600 hover:text-900 transition-duration-150 cursor-pointer mt-3 block">Contact</a>
                        </li>
                    </ul>
                </div>
                <div
                    class="col-12 sm:col-6 md:col-4 lg:col-3 flex flex-column mt-2 py-4 px-4 border-bottom-1 lg:border-y-none lg:border-right-1 surface-border">
                    <span class="text-900 text-xl block">Resources</span>
                    <ul class="list-none p-0">
                        <li>
                            <a tabindex="0" @click="processFooter3A"
                               class="text-600 hover:text-900 transition-duration-150 cursor-pointer mt-3 block">Free
                                Guide / Newsletter</a>
                        </li>
                        <li>
                            <a tabindex="0" @click="processFooter3B"
                               class="text-600 hover:text-900 transition-duration-150 cursor-pointer mt-3 block">Podcast</a>
                        </li>
                        <li>
                            <a tabindex="0" @click="processFooter3C"
                               class="text-600 hover:text-900 transition-duration-150 cursor-pointer mt-3 block">Investing
                                Quotes</a>
                        </li>
                        <li>
                            <a tabindex="0" @click="processFooter3D"
                               class="text-600 hover:text-900 transition-duration-150 cursor-pointer mt-3 block">12
                                Rules of Simply Investing</a>
                        </li>
                        <li>
                            <a tabindex="0" @click="processFooter3E"
                               class="text-600 hover:text-900 transition-duration-150 cursor-pointer mt-3 block">FAQs</a>
                        </li>
                    </ul>
                </div>
                <div class="col-12 sm:col-6 md:col-4 lg:col-3 flex flex-column mt-2 py-4 px-4 mb-4 lg:mb-0">
                    <span class="text-900 text-xl block">Follow Us</span>
                    <ul class="list-none p-0">
                        <li>
                            <a tabindex="0" @click="processFooter4A"
                               class="text-600 hover:text-900 transition-duration-150 cursor-pointer mt-3 block">YouTube</a>
                        </li>
                        <li>
                            <a tabindex="0" @click="processFooter4B"
                               class="text-600 hover:text-900 transition-duration-150 cursor-pointer mt-3 block">Facebook</a>
                        </li>
                        <li>
                            <a tabindex="0" @click="processFooter4C"
                               class="text-600 hover:text-900 transition-duration-150 cursor-pointer mt-3 block">Twitter</a>
                        </li>
                        <li>
                            <a tabindex="0" @click="processFooter4D"
                               class="text-600 hover:text-900 transition-duration-150 cursor-pointer mt-3 block">Instagram</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="surface-50 px-4 md:px-6 lg:px-8 border-1 surface-border border-x-none">
            <div class="center-footer py-5">
        <span>
            Copyright © 2025 Simply Investing. All rights reserved.&nbsp;&nbsp;
            <a href="https://simplyinvesting.com/disclaimer/" class="footer-links" target="_blank"
               rel="noopener noreferrer">Disclaimer.</a>&nbsp;&nbsp;
            <a href="https://simplyinvesting.com/terms/" class="footer-links" target="_blank"
               rel="noopener noreferrer">Terms of Use.</a>&nbsp;&nbsp;
            <a href="https://simplyinvesting.com/privacy/" class="footer-links" target="_blank"
               rel="noopener noreferrer">Privacy Policy.</a>
        </span>
            </div>
        </div>



    </div>


</template>

<script>
import UserService from "@/service/UserService";
import {useUserStore} from "@/stores/UserStore";
import ClientService from "@/service/ClientService";

export default {
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    props: {
        affiliateId: {
            type: String,
            required: false
        }
    },
    mounted() {
        UserService.getUserPing()
            .then(data => {
                console.log("[Login][mounted] System is active.");
                console.log("[Login][mounted] Data = ", data);
            })
            .catch(e => {
                console.log("[Login][mounted] System is NOT active.");
                console.log("[Login][mounted] Error = ", e);

                this.userStore.clearUser();
                // this.$router.push("login");
                this.$router.replace('/siLogin');
                window.location.reload();
            });

        document.title = "Simply Investing"; // Update the browser tab title
        this.setFavicon("images/blocks/logos/favicon.simplyinvesting.96x96.png");

        console.log('[Pricing][mounted] this.affiliateId = ', this.affiliateId);

        this.selectedCountry = this.countries.filter(country => country.code === 'US');

    },
    data() {
        return {
            activeTab: 1,
            userData: {},
            prospect: {},
            submitted: false,
            companyId: 114951,
            firstName: null,
            lastName: null,
            email: null,
            mobile: null,
            password: null,
            selectedPlan: "M",
            selectedLocation: null,
            selectedCountry: [],
            emailError: false,
            plans: [
                {name: 'Monthly', code: 'M'},
                {name: 'Annual', code: 'A'}
            ],
            locations: [
                {name: 'USD', code: 'US'},
                {name: 'CAD', code: 'CA'}
                // {name: 'GBP', code: 'UK'},
                // {name: 'ZAR', code: 'ZA'},
                // {name: 'Other', code: 'O'}
            ],
            countries: [
                {name: 'United States (NYSE, NASDAQ)', code: 'US'},
                {name: 'Canada (TSX)', code: 'CA'}
                // {name: 'UK (LSE)', code: 'UK'},
                // {name: 'South Africa (JSE)', code: 'ZA'}
            ],

        }
    },
    watch: {
        // Watch for changes in the email and validate
        email(value) {
            this.emailError = !this.isValidEmail(value);
        },
    },
    computed: {
        isFormValid() {
            // Check if all required fields are filled and email is valid
            return (
                this.firstName &&
                this.lastName &&
                this.email &&
                this.mobile &&
                this.password &&
                this.selectedLocation != null &&
                !this.emailError // Ensure no email error
            );
        },
        amount() {
            // Set default amount for cases where no options are selected
            let baseAmount = 0;
            let currency = "USD"

            // Example pricing logic:
            if (this.selectedLocation === 'CA') {
                currency = "CAD";
            } else if (this.selectedLocation === 'UK') {
                currency = "£";
            } else if (this.selectedLocation === 'ZA') {
                currency = "R";
            } else {
                currency = "USD";
            }

            if (this.selectedLocation === 'ZA') {
                baseAmount = 900;
            } else {
                baseAmount = 75;
            }

            if (this.selectedCountry != null) {
                if (this.selectedCountry.length > 1) {
                    if (this.selectedLocation === 'ZA') {
                        baseAmount += ((this.selectedCountry.length - 1) * 150);
                    } else {
                        baseAmount += ((this.selectedCountry.length - 1) * 15);
                    }
                }
            }

            if (this.selectedPlan === 'A') {
                baseAmount *= 6; // Apply annual multiplier
            }

            return `${currency} ${baseAmount}`;
        },
    },
    methods: {
        processHeaderApp() {
            window.open("https://simplyinvesting.com/app/", '_blank');
        },
        processHeaderCourse() {
            window.open("https://simplyinvesting.com/course/", '_blank');
        },
        processHeaderLogin() {
            window.open("https://app.simplyinvesting.com/#/siLogin", '_blank');
        },
        processHeaderSubscribe() {
            window.open("https://simplyinvesting.com/order/", '_blank');
        },
        processFooter1A() {
            window.open("https://simplyinvesting.com/app/", '_blank');
        },
        processFooter1B() {
            window.open("https://simplyinvesting.com/features/", '_blank');
        },
        processFooter1C() {
            window.open("https://simplyinvesting.com/stock-data/", '_blank');
        },
        processFooter1D() {
            window.open("https://simplyinvesting.com/course/", '_blank');
        },
        processFooter1E() {
            window.open("https://simplyinvesting.com/coaching/", '_blank');
        },
        processFooter2A() {
            window.open("https://simplyinvesting.com/dividend-investing-approach/", '_blank');
        },
        processFooter2B() {
            window.open("https://simplyinvesting.com/dividend-portfolio/", '_blank');
        },
        processFooter2C() {
            window.open("https://simplyinvesting.com/testimonials/", '_blank');
        },
        processFooter2D() {
            window.open("https://simplyinvesting.com/about/", '_blank');
        },
        processFooter2E() {
            window.open("https://simplyinvesting.com/contact/", '_blank');
        },
        processFooter3A() {
            window.open("https://simplyinvesting.com/signup/", '_blank');
        },
        processFooter3B() {
            window.open("https://simplyinvesting.com/podcast/", '_blank');
        },
        processFooter3C() {
            window.open("https://simplyinvesting.com/investing-quotes/", '_blank');
        },
        processFooter3D() {
            window.open("https://simplyinvesting.com/rules/", '_blank');
        },
        processFooter3E() {
            window.open("https://simplyinvesting.com/faq/", '_blank');
        },
        processFooter4A() {
            window.open("https://www.youtube.com/user/kanwalsarai", '_blank');
        },
        processFooter4B() {
            window.open("https://www.facebook.com/SimplyInvesting", '_blank');
        },
        processFooter4C() {
            window.open("https://x.com/kanwal_sarai?mx=2", '_blank');
        },
        processFooter4D() {
            window.open("https://www.instagram.com/simply.investing/", '_blank');
        },
        isValidEmail(email) {
            // Simple email validation regex
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        }
        ,
        setFavicon(url) {
            // Check if a <link rel="icon"> tag already exists
            let faviconLink = document.querySelector("link[rel='icon']");

            if (!faviconLink) {
                // Create a new <link> element if one doesn't exist
                faviconLink = document.createElement("link");
                faviconLink.rel = "icon";
                document.head.appendChild(faviconLink);
            }

            // Update the favicon URL
            faviconLink.href = url;
        },
        processBuy() {
            console.log("[Pricing][processBuy] this.selectedCountry = ", this.selectedCountry);
            console.log("[Pricing][processBuy] this.selectedCountry.length = ", this.selectedCountry.length);

            this.submitted = true;

            if (this.isFormValid) {

                try {

                    const customDataObj = {
                        siLocation: String(this.selectedLocation || ''), // Ensure string, fallback to empty string
                        siPlan: String(this.selectedPlan || ''),
                        siEnableUs: String(this.selectedCountry.some(country => country.code === 'US')), // Converts boolean to string
                        siEnableCa: String(this.selectedCountry.some(country => country.code === 'CA')),
                        siEnableUk: String(this.selectedCountry.some(country => country.code === 'UK')),
                        siEnableZa: String(this.selectedCountry.some(country => country.code === 'ZA')),
                        sendWelcomeEmail: String('Y')
                    };

                    // Verify that all keys and values are strings
                    const customDataObjAsStrings = Object.fromEntries(
                        Object.entries(customDataObj).map(([key, value]) => [String(key), String(value)])
                    );

                    var clientDto = {
                        firstName: String(this.firstName || ''),
                        lastName: String(this.lastName || ''),
                        email: String(this.email || ''),
                        mobile: String(this.mobile || ''),
                        password: String(this.password || ''),
                        rights: 'A',
                        status: 'I',
                        category: 'A',
                        affiliateClientId: this.affiliateId ? parseInt(this.affiliateId, 10) : null,
                        customData: customDataObjAsStrings
                    };

                    console.log('[Pricing][processBuy] clientDto = ', clientDto);

                    ClientService.createSiClient(clientDto)
                        .then(data => {
                            console.log("[Pricing][processBuy] Response data = ", data);

                            this.$toast.add({
                                severity: 'success',
                                summary: 'Successful',
                                detail: 'Successfully created account. Awaiting payment.',
                                life: 3000
                            });

                        })
                        .catch(e => {
                            console.log("[Pricing][processBuy] Error = ", e);
                            // this.$toast.add({
                            //     severity: 'error',
                            //     summary: 'Error',
                            //     detail: 'Failed to create account. Please try again.',
                            //     life: 3000
                            // });

                            if (e.response && e.response.status === 401) {
                                console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                                // this.$router.push('/siLogin'); // Redirect to the specified login route
                                this.$router.replace('/siLogin');
                            } else {
                                // Handle other errors (e.g., network issues)
                                this.userStore.clearUser();
                                // this.$router.push('login'); // This is your existing fallback redirect
                                this.$router.replace('/siLogin');
                            }
                            return;
                        });

                    // const response = await ClientService.createSiClient(clientDto);
                    // console.log('[Pricing][processBuy] Response = ', response);

                } catch (e) {
                    console.error('[Pricing][processBuy] Error:', e);

                    // this.$toast.add({
                    //     severity: 'error',
                    //     summary: 'Error',
                    //     detail: 'Failed to create account. Please try again.',
                    //     life: 3000
                    // });

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }
            }

            setTimeout(() => {
                if (this.selectedCountry.length === 2) {

                    if (this.selectedLocation === "CA") {
                        if (this.selectedPlan === 'A') {

                            // setTimeout(() => {
                            //     if (this.selectedLocation === "CA" && this.selectedPlan === 'A') {
                            //         window.top.location.href = "https://buy.stripe.com/123124sdsasdf";
                            //     }
                            // }, 500); // Small delay to ensure UI updates

                            window.top.location.href = "https://buy.stripe.com/5kA5lG7TDebe6LSdR3";
                            // window.open("https://buy.stripe.com/5kA5lG7TDebe6LSdR3", '_blank');
                        } else {
                            window.top.location.href = "https://buy.stripe.com/cN23dya1L7MQdag8wF";
                            // window.open("https://buy.stripe.com/cN23dya1L7MQdag8wF", '_blank');
                        }

                    } else if (this.selectedLocation === "UK") {
                        if (this.selectedPlan === 'A') {
                            window.top.location.href = "https://buy.stripe.com/aEU6pK2zj7MQ1ry5kN";
                            // window.open("https://buy.stripe.com/aEU6pK2zj7MQ1ry5kN", '_blank');
                        } else {
                            window.top.location.href = "https://buy.stripe.com/4gwdScddXgjm8U06oN";
                            // window.open("https://buy.stripe.com/4gwdScddXgjm8U06oN", '_blank');
                        }

                    } else if (this.selectedLocation === "ZA") {
                        if (this.selectedPlan === 'A') {
                            window.top.location.href = "https://buy.stripe.com/cN25lGgq91os3zG6oY";
                            // window.open("https://buy.stripe.com/cN25lGgq91os3zG6oY", '_blank');
                        } else {
                            window.top.location.href = "https://buy.stripe.com/00gg0kei19UYfio6oV";
                            // window.open("https://buy.stripe.com/00gg0kei19UYfio6oV", '_blank');
                        }

                    } else {
                        if (this.selectedPlan === 'A') {
                            window.top.location.href = "https://buy.stripe.com/fZe5lG4Hr9UYfio4gm";
                            // window.open("https://buy.stripe.com/fZe5lG4Hr9UYfio4gm", '_blank');
                        } else {
                            window.top.location.href = "https://buy.stripe.com/8wMbK48XH6IM0nudQS";
                            // window.open("https://buy.stripe.com/8wMbK48XH6IM0nudQS", '_blank');
                        }
                    }

                } else if (this.selectedCountry.length === 3) {
                    if (this.selectedLocation === "CA") {
                        if (this.selectedPlan === 'A') {
                            window.top.location.href = "https://buy.stripe.com/6oE7tOfm58QU6LS14i";
                            // window.open("https://buy.stripe.com/6oE7tOfm58QU6LS14i", '_blank');
                        } else {
                            window.top.location.href = "https://buy.stripe.com/bIY8xSddXc365HO4gq";
                            // window.open("https://buy.stripe.com/bIY8xSddXc365HO4gq", '_blank');
                        }

                    } else if (this.selectedLocation === "UK") {
                        if (this.selectedPlan === 'A') {
                            window.top.location.href = "https://buy.stripe.com/8wM8xS3Dn5EI7PW9B4";
                            // window.open("https://buy.stripe.com/8wM8xS3Dn5EI7PW9B4", '_blank');
                        } else {
                            window.top.location.href = "https://buy.stripe.com/6oEg0k1vfaZ2c6c14u";
                            // window.open("https://buy.stripe.com/6oEg0k1vfaZ2c6c14u", '_blank');
                        }

                    } else if (this.selectedLocation === "ZA") {
                        if (this.selectedPlan === 'A') {
                            window.top.location.href = "https://buy.stripe.com/4gw3dy1vfgjmfiocNn";
                            // window.open("https://buy.stripe.com/4gw3dy1vfgjmfiocNn", '_blank');
                        } else {
                            window.top.location.href = "https://buy.stripe.com/cN29BW1vfgjm0nudRo";
                            // window.open("https://buy.stripe.com/cN29BW1vfgjm0nudRo", '_blank');
                        }

                    } else {
                        if (this.selectedPlan === 'A') {
                            window.top.location.href = "https://buy.stripe.com/5kA4hC8XH6IM8U0007";
                            // window.open("https://buy.stripe.com/5kA4hC8XH6IM8U0007", '_blank');
                        } else {
                            window.top.location.href = "https://buy.stripe.com/dR63dygq93wA2vC003";
                            // window.open("https://buy.stripe.com/dR63dygq93wA2vC003", '_blank');
                        }
                    }

                } else if (this.selectedCountry.length === 4) {
                    if (this.selectedLocation === "CA") {
                        if (this.selectedPlan === 'A') {
                            window.top.location.href = "https://buy.stripe.com/3cs6pK4Hr0kofio8wL";
                            // window.open("https://buy.stripe.com/3cs6pK4Hr0kofio8wL", '_blank');
                        } else {
                            window.top.location.href = "https://buy.stripe.com/fZe15q7TD5EIeek14f";
                            // window.open("https://buy.stripe.com/fZe15q7TD5EIeek14f", '_blank');
                        }

                    } else if (this.selectedLocation === "UK") {
                        if (this.selectedPlan === 'A') {
                            window.top.location.href = "https://buy.stripe.com/4gw15qa1Lffi3zGbJd";
                            // window.open("https://buy.stripe.com/4gw15qa1Lffi3zGbJd", '_blank');
                        } else {
                            window.top.location.href = "https://buy.stripe.com/eVa8xS8XH2sw9Y4fZp";
                            // window.open("https://buy.stripe.com/eVa8xS8XH2sw9Y4fZp", '_blank');
                        }

                    } else if (this.selectedLocation === "ZA") {
                        if (this.selectedPlan === 'A') {
                            window.top.location.href = "https://buy.stripe.com/8wMbK4gq92sw0nubJk";
                            // window.open("https://buy.stripe.com/8wMbK4gq92sw0nubJk", '_blank');
                        } else {
                            window.top.location.href = "https://buy.stripe.com/7sI6pKfm5ffigms8x5";
                            // window.open("https://buy.stripe.com/7sI6pKfm5ffigms8x5", '_blank');
                        }

                    } else {
                        if (this.selectedPlan === 'A') {
                            window.top.location.href = "https://buy.stripe.com/fZe6pK4Hrgjm0nuaEM";
                            // window.open("https://buy.stripe.com/fZe6pK4Hrgjm0nuaEM", '_blank');
                        } else {
                            window.top.location.href = "https://buy.stripe.com/5kA9BW8XHd7a6LSbIM";
                            // window.open("https://buy.stripe.com/5kA9BW8XHd7a6LSbIM", '_blank');
                        }
                    }

                } else {
                    if (this.selectedLocation === "CA") {
                        if (this.selectedPlan === 'A') {
                            window.top.location.href = "https://buy.stripe.com/28og0k6Pz0ko5HO00c";
                            // window.open("https://buy.stripe.com/28og0k6Pz0ko5HO00c", '_blank');
                        } else {
                            window.top.location.href = "https://buy.stripe.com/cN24hC4Hr3wA4DK4gg";
                            // window.open("https://buy.stripe.com/cN24hC4Hr3wA4DK4gg", '_blank');
                        }

                    } else if (this.selectedLocation === "UK") {
                        if (this.selectedPlan === 'A') {
                            window.top.location.href = "https://buy.stripe.com/eVag0k4Hr4AE4DK28A";
                            // window.open("https://buy.stripe.com/eVag0k4Hr4AE4DK28A", '_blank');
                        } else {
                            window.top.location.href = "https://buy.stripe.com/bIY7tOddX0ko2vC3cA";
                            // window.open("https://buy.stripe.com/bIY7tOddX0ko2vC3cA", '_blank');
                        }

                    } else if (this.selectedLocation === "ZA") {
                        if (this.selectedPlan === 'A') {
                            window.top.location.href = "https://buy.stripe.com/4gwaG0a1L1osgms9AU";
                            // window.open("https://buy.stripe.com/4gwaG0a1L1osgms9AU", '_blank');
                        } else {
                            window.top.location.href = "https://buy.stripe.com/aEU3dyei1ebe4DKdRm";
                            // window.open("https://buy.stripe.com/aEU3dyei1ebe4DKdRm", '_blank');
                        }

                    } else {
                        if (this.selectedPlan === 'A') {
                            window.top.location.href = "https://buy.stripe.com/bIYaG0ddX9UYc6c9AF";
                            // window.open("https://buy.stripe.com/bIYaG0ddX9UYc6c9AF", '_blank');
                        } else {
                            window.top.location.href = "https://buy.stripe.com/dR68xSei1c36eek3cd";
                            // window.open("https://buy.stripe.com/dR68xSei1c36eek3cd", '_blank');
                        }
                    }

                }

            }, 500); // Small delay to ensure UI updates

            this.submitted = false;

        }
    }
}
;
</script>

<style scoped>
a {
    text-decoration: none;
}

.custom-button {
    background-color: #2E5439; /* Button background color */
    color: white; /* Button text color */
    border: none; /* Remove border if needed */
}

.custom-button:hover {
    background-color: #3E6948; /* Slightly lighter shade for hover effect */
}

.footer-links {
    color: var(--primary-color); /* Use PrimeVue theme color */
    text-decoration: none;
    font-weight: normal;
}

.footer-links:hover {
    text-decoration: underline;
}

.center-footer {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}

</style>
